import React, { useState, useEffect } from "react"
import axios from "axios"
import EditLeadModal from "../Lead/EditLeadModal"
import { getCurrentUser } from "../../helpers/Utils"

const GlobalLeadModal = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [leadData, setLeadData] = useState(null)
  const [loading, setLoading] = useState(false)

  // Add test functionality - can be removed after testing
  useEffect(() => {
    // Add a global function for testing
    window.testLeadMaturedNotification = leadId => {
      const event = new CustomEvent("openEditLeadModal", {
        detail: { leadId: leadId },
      })
      window.dispatchEvent(event)
    }

    return () => {
      delete window.testLeadMaturedNotification
    }
  }, [])

  useEffect(() => {
    const handleOpenModal = async event => {
      const { leadId } = event.detail

      if (!leadId) {
        return
      }

      try {
        setLoading(true)
        // Fetch the lead data
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
            "company_name"
          )}/lead/${leadId}`,
          {
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${getCurrentUser()?.token || ""}`,
            },
          }
        )

        if (response.data.status && response.data.data) {
          setLeadData(response.data.data)
          setModalOpen(true)
        }
      } catch (error) {
      } finally {
        setLoading(false)
      }
    }

    // Listen for the custom event
    window.addEventListener("openEditLeadModal", handleOpenModal)

    // Cleanup
    return () => {
      window.removeEventListener("openEditLeadModal", handleOpenModal)
    }
  }, [])

  const handleCloseModal = shouldClose => {
    if (shouldClose === false || shouldClose === undefined) {
      setModalOpen(false)
      setLeadData(null)
    }
  }

  if (!modalOpen || !leadData) {
    return null
  }

  // No-op functions for optional props
  const noOpFunction = () => {}

  return (
    <EditLeadModal
      modal_standard={modalOpen}
      setmodal_standard={handleCloseModal}
      lead={leadData}
      setLead={setLeadData}
      module="lead"
      getAllLeads={noOpFunction}
      followupCounts={noOpFunction}
      setLoader3={noOpFunction}
      setIsOpen={noOpFunction}
    />
  )
}

export default GlobalLeadModal
